import React, { useContext, FunctionComponent, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// Custom Components
import { useTheme } from '@mui/material';
import DynamicDialog from '@/ui/Dialog/DynamicDialog';
import DialogToolbarHeading from '@/ui/Dialog/DialogToolbarHeading';
import DialogToolbarButtonClose from '@/ui/Dialog/ToolbarButtons/DialogToolbarButtonClose';
import ToolbarFillContent from '@/ui/Toolbar/ToolbarFillContent';
import DialogActionButtonClose from '@/ui/Dialog/ActionButtons/DialogActionButtonClose';
import DialogContext, { IDialogProps } from '@/context/DialogContext/DialogContext';
import ModelTable from '@/ui/Table/ModelTable';
import TableButtonView from '@/ui/Table/ActionButtons/TableButtonView';
import DataController from '@/lib/DataController';
import modelKoncesija from '@/models/koncesija';

// Types
import { ClosingDetails } from '@/@types/components/formController';
import { DCRecord } from '@/@types/lib/dataController';
import KoncesijeDialog from './KoncesijaDialog';
import { BackgroundColorObj } from '@/@types/ui/Table';

const title = 'koncesije:titles.history_dialog';

const KoncesijaHistoryDialog: FunctionComponent<IDialogProps> = (props) => {
  const { showDialog, hideDialog } = useContext(DialogContext);
  const theme = useTheme();
  const { t } = useTranslation();

  const [historyRecords, setHistoryRecords] = useState<DCRecord[]>([]);

  const { onClose, level, gid } = props;

  const dc = new DataController(modelKoncesija);

  useEffect(() => {
    dc.GetData(`${modelKoncesija.apiPath}/${gid}/history`).then((resp) => {
      if (resp.success) {
        setHistoryRecords(resp.data as DCRecord[]);
      } else {
        // warning message maybe idk
      }
    });
  }, []);

  const handleClose = () => {
    // close
    close({ dataChanged: false, action: 'cancel' });
  };

  const close = (result: ClosingDetails) => {
    onClose(result);
    hideDialog(level);
  };

  const handleView = (evt: React.SyntheticEvent, sel: { [key: string]: DCRecord }) => {
    const selId = parseInt(Object.keys(sel)[0], 10);
    const record: DCRecord = sel[selId];
    showDialog(
      KoncesijeDialog,
      {
        dc,
        mode: 'view',
        form: 'history',
        recordId: record.id,
        onClose: handleSecondaryDialogClose,
        level: 2,
      },
      2
    );
  };

  const handleSecondaryDialogClose = () => {
    hideDialog(2);
  };

  const handleRowStyle: (id: number) => BackgroundColorObj | {} = (id: number) => {
    const record = historyRecords.find((rec) => rec.id === id);
    if (record?.is_newest) {
      return { backgroundColor: `${theme.palette.success.light}50` };
    }
    return {};
  };

  return (
    <DynamicDialog open maxWidth="xl" onClose={handleClose}>
      <DialogTitle>
        <Toolbar variant="dense" disableGutters>
          <DialogToolbarHeading>{t(title)}</DialogToolbarHeading>
          <ToolbarFillContent />
          <DialogToolbarButtonClose onClick={handleClose} />
        </Toolbar>
      </DialogTitle>
      <DialogContent>
        <Box m={2}>
          <ModelTable
            title=""
            records={historyRecords}
            dc={dc}
            allowSelection="one"
            allowColumnPicker
            allowExport
            allowAdd={false}
            onRowAction={() => {}}
            allowRowAction={() => false}
            viewName="history"
            getRowStyle={handleRowStyle}
          >
            <TableButtonView variant="contained" onClick={handleView} />
          </ModelTable>
        </Box>
      </DialogContent>
      <DialogActions>
        <DialogActionButtonClose variant="outlined" onClick={handleClose} />
      </DialogActions>
    </DynamicDialog>
  );
};

export default KoncesijaHistoryDialog;
